<template>
    <div class="edit-date" v-on:click.stop>
        <h5>{{title}}</h5>

        <flat-pickr v-model="editingDate" v-bind:config="flatPickrConfig" id="date"></flat-pickr>

        <div v-show="updating">
            <Spinner/>
        </div>

        <div v-if="infoMessage" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
            {{infoMessage}}
        </div>

        <div v-show="!updating && !success" class="edit-date_buttons">
            <button v-on:click.stop="save" class="btn btn-primary">Save</button>
            <button v-on:click.stop="close" class="btn btn-normal">Cancel</button>
        </div>
    </div>
</template>

<script>
    import FlatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import 'flatpickr/dist/themes/material_blue.css';

    import Spinner from '../components/Spinner.vue'

    export default {
        name: 'EditDate',
        components: {
            FlatPickr, Spinner
        },
        props: {
            title: String,
            date: String,
            minDate: String,
            ownerReference: String,
            updating: Boolean,
            success: Boolean,
            error: Boolean,
            infoMessage: String
        },
        data: function () {
            return {
                editingDate: null,
                flatPickrConfig: {
                    mode: "single",
                    enableTime: true,
                    time_24hr: true,
                    altInput: true,
                    altFormat: "j M @ H:i",
                    dateFormat: "Z",
                    inline: true,
                    minDate: this.minDate
                },
            }
        },
        computed: {

        },
        methods: {
            save: function () {
                setTimeout(() => {
                    this.$root.$emit('save-edit-date', this.ownerReference, this.editingDate);
                }, 400);
            },
            close: function () {
                this.$root.$emit('close-edit-date');
            }
        },
        mounted() {
            this.editingDate = this.date;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/components/modal";
    @import "../styles/components/edit_date";
</style>

<!--These are overrides for the flatpickr inputs -->
<style lang="scss">
    @import "../styles/overrides/flatpickr";
    @import "../styles/overrides/flatpickr_edit_date";
</style>
